import { profileKey } from '@staffedupusa/shared-components';
import { useMutation, useQueryClient } from 'react-query';

import { updateWalkthroughStatusRoute } from '@features/profile';
import axiosInstance from '@server/axiosInstance';

export const useUpdateWalkthroughStatus = () => {
  const client = useQueryClient();

  const { mutate: updateWalkthroughStatus } = useMutation({
    mutationFn: () =>
      axiosInstance.post(updateWalkthroughStatusRoute).then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries([profileKey]);
      }
    },
  });

  return {
    updateWalkthroughStatus,
  };
};
